import { useState } from "react";
import { useLocalization } from "../../hooks/useLocalization";
import { ROLE_ICON_URL, ROLE_SHORT_LABEL, type PlayerRole } from "../../utils/leaderboard/roles";

interface PlayerRoleBadgeProps {
  role: PlayerRole | null | undefined;
  small?: boolean;
}

/** Kept as a class hook so host pages (e.g. player profile tables) can restyle the badge. */
const BADGE_BASE = "player-role-badge inline-flex shrink-0 items-center justify-center";

export const PlayerRoleBadge = ({ role, small = false }: PlayerRoleBadgeProps) => {
  const { strings } = useLocalization();
  const [useTextFallback, setUseTextFallback] = useState(false);

  if (!role) {
    return null;
  }

  const size = small ? 16 : 18;
  const roleLabel = strings.SEASON_STATS.ROLES[role];

  if (useTextFallback) {
    return (
      <span
        className={`${BADGE_BASE} rounded-md bg-[rgba(123,147,255,0.14)] font-bold tracking-[0.06em] text-[#7b93ff] ${
          small
            ? "px-[0.35rem] py-[0.1rem] text-[0.62rem]"
            : "px-[0.45rem] py-[0.15rem] text-[0.68rem]"
        }`}
        title={roleLabel}
      >
        {ROLE_SHORT_LABEL[role]}
      </span>
    );
  }

  return (
    <span className={BADGE_BASE} title={roleLabel}>
      <img
        className="block opacity-[0.92]"
        src={ROLE_ICON_URL[role]}
        alt={roleLabel}
        width={size}
        height={size}
        onError={() => {
          setUseTextFallback(true);
        }}
      />
    </span>
  );
};
